import React, { useEffect } from 'react';
import Me from './Me.jpg';
import Me_at_Company_Picnic_2001 from './Me_at_Company_Picnic_2001.jpg';
import Me_10_21_2000 from './Me_10-21-2000.jpg';
import LinkList from '../LinkList';
import { addRoute } from '../../GlobalRoutes';
import { MyImage } from '../Gallery';

import Office_01 from './Work/Office_01.jpg';
import Office_02 from './Work/Office_02.jpg';
import Office_03 from './Work/Office_03.jpg';
import Office_View_01 from './Work/Office_View_01.jpg';
import Office_View_02 from './Work/Office_View_02.jpg';
import image100_2268 from './Work/100_2268.JPG';
import image100_2269 from './Work/100_2269.JPG';
import image100_2271 from './Work/100_2271.JPG';
import image100_2272 from './Work/100_2272.JPG';
import image100_2273 from './Work/100_2273.JPG';
import image100_2276 from './Work/100_2276.JPG';

import AI from './MovieStubs/AI.jpg';
import Americas_Sweethearts from './MovieStubs/America\'s Sweethearts.jpg';
import American_Pie_2 from './MovieStubs/American Pie 2.jpg';
import Best_in_Show from './MovieStubs/Best in Show.jpg';
import Bounce from './MovieStubs/Bounce.jpg';
import Bridget_Joness_Diary from './MovieStubs/Bridget Jones\'s Diary.jpg';
import Captain_Corellis_Mandolin from './MovieStubs/Captain Corelli\'s Mandolin.jpg';
import Chocolat from './MovieStubs/Chocolat.jpg';
import Crouching_Tiger_Hidden_Dragon from './MovieStubs/Crouching Tiger, Hidden Dragon.jpg';
import Dracula from './MovieStubs/Dracula.jpg';
import How_the_Grinch_Stole_Christmas from './MovieStubs/How the Grinch Stole Christmas.jpg';
import Jeepers_Creepers from './MovieStubs/Jeepers Creepers.jpg';
import Jurassic_Park_III from './MovieStubs/Jurassic Park III.jpg';
import KPAX from './MovieStubs/K-PAX.jpg';
import Kiss_of_the_Dragon from './MovieStubs/Kiss of the Dragon.jpg';
import Legally_Blonde from './MovieStubs/Legally Blonde.jpg';
import Miss_Congeniality from './MovieStubs/Miss Congeniality.jpg';
import Pay_It_Forward from './MovieStubs/Pay It Forward.jpg';
import Quills from './MovieStubs/Quills.jpg';
import Rush_Hour_2 from './MovieStubs/Rush Hour 2.jpg';
import Save_the_Last_Dance from './MovieStubs/Save the Last Dance.jpg';
import Say_It_Isnt_So from './MovieStubs/Say It Isn\'t So.jpg';
import Shrek from './MovieStubs/Shrek.jpg';
import The_6th_Day from './MovieStubs/The 6th Day.jpg';
import The_Family_Man from './MovieStubs/The Family Man.jpg';
import The_Mexican from './MovieStubs/The Mexican.jpg';
import The_Score from './MovieStubs/The Score.jpg';
import The_Wedding_Planner from './MovieStubs/The Wedding Planner.jpg';
import Thirteen_Days from './MovieStubs/Thirteen Days.jpg';
import Tomb_Raider from './MovieStubs/Tomb Raider.jpg';
import Traffic from './MovieStubs/Traffic.jpg';
import Vanilla_Sky from './MovieStubs/Vanilla Sky.jpg';


import AboutMeFamily from './Family/index';
import AboutMeComedy from './Comedy/index';
import AboutMeTraveled from './Traveled/index';

export const aboutMeLinks = [
  { text: 'About Me Home', url: '/about-me' },
  { text: 'Family', url: '/about-me-family' },
  { text: 'Lived', url: '/about-me-lived' },
  { text: 'Traveled', url: '/about-me-traveled' },
  { text: 'Worked', url: '/about-me-worked' },
  { text: 'Entertainment', url: '/about-me-entertainment' },
  { text: 'Comedy', url: '/about-me-comedy' }
];

function Content(props) {
  return (
    <table cellPadding="10" width="100%" height="100%" border="0">
      <tbody>
        <tr>
          <LinkList links={aboutMeLinks} />
          <td valign="top">
            <div className="content">{props.children}</div>
          </td>
        </tr>
      </tbody>
    </table>
  );
}

export const AboutMe=() => {
  useEffect(() => {
    document.title = 'TomsSpot.com - About Me';
  });

  return (
    <Content>
      <p><font size="6">Some pictures of me over the years</font></p>
      <div><MyImage src={Me} alt="Me at work at Microsoft, waiting for Y2K issues that never happened on 12/31/1999" /></div>
      <div><MyImage src={Me_10_21_2000} alt="Me in my apartment on 10/21/2000" /></div>
      <div><MyImage src={Me_at_Company_Picnic_2001} alt="Me at the Microsoft Company Meeting 2001" /></div>
    </Content>
  );
}

function AboutMeLived() {
  useEffect(() => {
    document.title = 'TomsSpot.com - About Me - Lived';
  });

  return (
    <Content>
      <p><font size="6">Places I Have Lived</font></p>
      <p className="left-justify">
        My life started out in <a href="https://www.cityofconcord.org/" target="_blank" rel="noreferrer">Concord</a>, California. Shortly before starting kindergarten I moved to Carmichael, California, and lived there until just before the end of third grade. This time I moved a little further, all the way to Dhahran, <a href="http://www.saudiembassy.net/"   target="_blank" rel="noreferrer">Saudi Arabia</a> for my dad's new job working for <a href="https://www.aramco.com/"   target="_blank" rel="noreferrer">ARAMCO</a>. Moving to Saudi Arabia was a big change from living in California. When I got off the airplane it felt like I was walking into the oven. School for the American children only went up to ninth grade so for High School I went to two boarding schools.  One in <a href="https://www.kentshill.org/"   target="_blank" rel="noreferrer">Kents Hill</a>, Maine and the other in <a href="https://www.fryeburgacademy.org/" target="_blank" rel="noreferrer">Fryeburg</a>, Maine. After I graduated from High School my parents decided to move back to the states and start a business, which the whole family was involved in. The business was located in <a href="https://www.reno.gov/"   target="_blank" rel="noreferrer">Reno</a>, Nevada. We ran that business for a couple of years then decided to sell it so that we could move to <a href="https://www.seattle.gov/" target="_blank" rel="noreferrer">Seattle</a>, Washington to purchase some other locations for the same business that we were involved in. I worked for my parents for about six and a half years and decided to join the <a href="http://www.army.mil/"   target="_blank" rel="noreferrer">Army</a>. During my enlistment I was in Desert Storm, stationed back in Saudi Arabia. That was a lot of fun to have been able to travel around the country that I grew up in, although I was not able to visit the compound that my family lived on. After getting back from Desert Storm I was station at <a href="https://home.army.mil/liberty/index.php"   target="_blank" rel="noreferrer">Fort Bragg</a>, now Fort Liberty, in North Carolina for a couple of months before moving to <a href="https://en.wikipedia.org/wiki/Ray_Barracks" target="_blank" rel="noreferrer">Ray Barracks</a> in Friedberg, Germany for two years, where Elvis was stationed. Once my tour was over in Germany I was stationed at <a href="https://home.army.mil/lewis-mcchord/index.php"   target="_blank" rel="noreferrer">Fort Lewis</a> in Washington, which was only forty-five minutes from where my family lives. After getting out of the Army I lived in <a href="https://wa.gov/" target="_blank" rel="noreferrer">Washington</a>. For 10 years I lived in <a href="http://www.ci.woodinville.wa.us/" target="_blank" rel="noreferrer">Woodinville</a>, but I also lived in <a href="https://www.redmond.gov/" target="_blank" rel="noreferrer">Redmond</a>, <a href="https://www.kirklandwa.gov/Home" target="_blank" rel="noreferrer">Kirkland</a> and <a href="https://www.bothellwa.gov/" target="_blank" rel="noreferrer">Bothell</a>, and another 12 years living in <a href="https://www.redmond.gov/" target="_blank" rel="noreferrer">Redmond</a>.
      </p>
      <p className="left-justify">
        After living in Washington state for over 30 years I moved to <a href="https://www.chandleraz.gov/" target="_blank" rel="noreferrer">Chandler, AZ</a> in March 2015.  However, I couldn't stay away for long because I moved back to Washington state in August 2016.  Living in <a href="https://www.redmond.gov/" target="_blank" rel="noreferrer">Redmond</a> for a year before moving to where I live now in <a href="https://www.kirklandwa.gov/Home" target="_blank" rel="noreferrer">Kirkland</a>.
      </p>
    </Content>
  );
}

const calculateEmploymentDuration = (startDate, endDate) => {
  const start = new Date(startDate);
  const end = endDate ? new Date(endDate) : new Date();
  let years = end.getFullYear() - start.getFullYear();
  let months = end.getMonth() - start.getMonth();

  if (months < 0) {
    years--;
    months += 12;
  }

  return { years, months };
};

const getTotalEmploymentDuration = () => {
  const devPeriod = calculateEmploymentDuration('1999-03-23', null);
  const firstPeriod = calculateEmploymentDuration('1999-12-28', '2014-09-14');
  const secondPeriod = calculateEmploymentDuration('2018-05-15', null);
  let totalYears = firstPeriod.years + secondPeriod.years;
  let totalMonths = firstPeriod.months + secondPeriod.months;
  if (totalMonths >= 12) {
    totalYears += Math.floor(totalMonths / 12); totalMonths = totalMonths % 12;
  }
  return `${totalYears} years and ${totalMonths} months, out of ${devPeriod.years} years and ${devPeriod.months} months working in software development`;
};

function AboutMeWorked() {
  useEffect(() => {
    document.title = 'TomsSpot.com - About Me - Worked';
  });

  const employmentDuration = getTotalEmploymentDuration();

  const officeImages = [
    { src: Office_View_01, alt: "Office View 01" },
    { src: Office_View_02, alt: "Office View 02" },
    { src: Office_01, alt: "Office 01" },
    { src: Office_02, alt: "Office 02" },
    { src: Office_03, alt: "Office 03" }
  ];

  const officeImagePairs = [];
  for (let i = 0; i < officeImages.length; i += 2) {
    officeImagePairs.push(officeImages.slice(i, i + 2));
  }

  const images = [
    { src: image100_2273, alt: "2273" },
    { src: image100_2269, alt: "2269" },
    { src: image100_2268, alt: "2268" },
    { src: image100_2272, alt: "2272" },
    { src: image100_2271, alt: "2271" },
    { src: image100_2276, alt: "2276" }
  ];

  const imagePairs = [];
  for (let i = 0; i < images.length; i += 2) {
    imagePairs.push(images.slice(i, i + 2));
  }

  return (
    <Content>
      <p><font size="6">Places I Have Worked</font></p>
      <p className="left-justify">
        <a href="https://www.linkedin.com/in/tomrlake/" title="Go to My LinkedIn" target="_blank" rel="noreferrer">
        My LinkedIn</a>
      </p>
      <p className="left-justify">
        I started working at <a href="http://www.microsoft.com/" title="Go to Microsoft Homepage" target="_blank" rel="noreferrer">
        Microsoft</a> on 3/23/99 as a contractor.  My first position I was a Support 
        Engineer in Developer Support working with <a href="https://learn.microsoft.com/dotnet/visual-basic/?WT.mc_id=dotnet-35129-website" title="Go to Visual Basic Homepage" target="_blank" rel="noreferrer">
        Visual Basic</a> (VB) and eMbedded Visual Basic (eVB). It was my job to help 
        people resolve problems that they were having programming in VB and eVB. You 
        would have called me if you had just finished programming and testing an 
        application, and were now trying to create a setup package to install the 
        application onto another computer, and you were getting errors during or 
        immediately after the installation. You would've contacted me if you were 
        still writing your application and you were getting an error that you could 
        not figure out how to resolve. One of the biggest parts, and most enjoyable, 
        is user education. What I mean by this is that it was my job to help to show 
        new users of VB, and people that have been programming for sometime but not 
        with VB, how to do what they want to do or sometimes explain why they should 
        not be doing what they are trying to do. After nine months as a contractor I 
        was hired full time on 12/28/99.
      </p>
      <p className="left-justify">
        On 11/27/00 I changed positions and moved over to one of the product team, <a href="https://learn.microsoft.com/biztalk/core/introducing-biztalk-server" title="Go to BizTalk Server Homepage" target="_blank" rel="noreferrer">BizTalk Server</a>,
        as a Software Test Engineer (STE).  I have worked on several different 
        projects while on the team so far.  The first was to test the new website 
        BizTalk.org, which is no longer being used.  
        The site was used to host XML Schemas used with BizTalk.  Next I worked on 
        testing a new driver that integrates with another product, Application 
        Center 2000, which is used to replicate BizTalk configuration information from 
        one computer to another.  After working on testing the product I also wrote a chapter in
        a new book about deploying BizTalk Server configurations using Application Center.  Click <a href="http://www.amazon.com/exec/obidos/ASIN/0672321769/qid%3D1025190841/002-2768922-2986403" 
        title="Click here to see my book." target="_blank" rel="noreferrer">here</a> to take a look at "BizTalk Unleashed".  Then I 
        worked on BizTalk Server 2004 which was released April 1, 2004.
      </p>
      <p className="left-justify">
        About 8 months before the release of BizTalk 2004 a small group of us started working 
        on one of the newest components of <a href="http://msdn.microsoft.com/netframework/default.aspx" title="Go to .NET Developer Center" target="_blank" rel="noreferrer">.NET 3.0</a>, <a href="https://learn.microsoft.com/dotnet/framework/windows-workflow-foundation/" title="Go to Windows Workflow Foundation Homepage" target="_blank" rel="noreferrer">Windows Workflow Foundation</a>.
        I worked on it for over two years.  Until the public announcement on 
        9/14/2005 at PDC2005 I couldn't tell anyone about it, including my mom.	It is really 
        amazing to be a part of a new technology that had such a large potential to impact on how 
        software is written for years to come.  
      </p>
      <p className="left-justify">
        Below are pictures of my office when I was in Building 3, on Microsoft's main Redmond campus, taken on 
        6/26/2002 before building 36 was built.
      </p>
      <div className="left-justify">
        <table align="center">
          <tbody>
            {officeImagePairs.map((pair, index) => (
              <tr key={index}>
                {pair.map((image, idx) => (
                  <td key={idx}>
                    <div><MyImage src={image.src} alt={image.alt} maxWidth={500} maxHeight={500} /></div>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="left-justify">
        <font size="3">
        The pictures below are of the same office from above, before moving out of the build, you can see building 36 is completed.
        </font>
      </p>
      <div className="left-justify">
        <table align="center">
          <tbody>
            {imagePairs.map((pair, index) => (
              <tr key={index}>
                {pair.map((image, idx) => (
                  <td key={idx}>
                    <div><MyImage src={image.src} alt={image.alt} maxWidth={500} maxHeight={500} /></div>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="left-justify">
        <font size="3">
        After Windows Workflow Foundation was finished I worked on testing some new activities that enabled the creation of <a href="https://learn.microsoft.com/dotnet/framework/wcf/" title="Go to Windows Communication Foundation Homepage" target="_blank" rel="noreferrer">Windows Communication Foundation</a> services using workflow activities which shipped with Visual Studio 2008.  This was followed by the next version of workflow that was shipped as a part of .NET Framework 4.0. After almost 8 years on the same team I decided it was time for a change.  Starting on 9/15/2008 I began working on the <a href="http://www.mesh.com" title="Go to the Live Mesh site" target="_blank" rel="noreferrer">Live Mesh and Developer Platform</a> team. I also worked on <a href="https://www.microsoft.com/system-center" title="Go to the System Center site" target="_blank" rel="noreferrer">System Center</a> and <a href="http://azure.microsoft.com/services/documentdb/" title="Go to the Azure DocumentDB site" target="_blank" rel="noreferrer">Azure DocumentDB</a> before leaving Microsoft after almost 15 years.
        </font>
      </p>
      <p className="left-justify">
        <font size="3">
        After leaving Microsoft I decided to move to Arizona and try working as a consultant.  I worked for <a href="http://www.neudesic.com/" title="Go to the Neudesic site" target="_blank" rel="noreferrer">Neudesic</a> as a Senior Consultant in QA for a little over a year, but consulting was not for me.  I decided to move back to Washington and got a job working for CenturyLink on their <a href="https://www.ctl.io/" title="Go to the CenturyLink Cloud site" target="_blank" rel="noreferrer">Cloud</a> team, where I worked for about 1 1/2 years.
        </font>
      </p>
      <p className="left-justify">
        <font size="3">
        I was drawn back to work at Microsoft in May 2018, working on the <a href="https://azure.microsoft.com/products/cosmos-db/" title="Go to the Azure Cosmos DB site" target="_blank" rel="noreferrer">Azure Cosmos DB</a> team, where I worked for a little over 6 years.  Starting in June 2024 I started working on the Azure CXP Solutions team, supporting over 150 partner teams across <a href="https://azure.microsoft.com/" title="Azure" target="_blank" rel="noreferrer">Azure</a>.  They use the infrastructure that my team builds and maintains to help solve their customer issues. I have worked for Microsoft for {employmentDuration}.
        </font>
      </p>
    </Content>
  );
}

const MovieTable = ({ title, movies }) => {
  return (
    <div>
      <table cellSpacing="1" cellPadding="1" width="100%" border="0" align="center">
        <tbody>
          <tr>
            <td width="100%">
              <font size="4">{title}</font>
            </td>
          </tr>
        </tbody>
      </table>
      <table cellSpacing="1" cellPadding="1" width="100%" border="0" align="center">
        <tbody>
          {movies.map((movie, index) => (
            <tr key={index}>
              <td width="110" align="center">
                <MyImage src={movie.src} alt={movie.alt} />
              </td>
              <td>
                <font size="3">
                  {movie.description || movie.alt} <a href={`https://www.imdb.com/title/${movie.link}`} target="_blank" rel="noreferrer">Link for Info</a>
                </font>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};


function AboutMeEntertainment() {
  useEffect(() => {
    document.title = 'TomsSpot.com - About Me - Entertainment';
  });

  const onVideoMovies = [
    {
      src: The_Score,
      alt: "The Score",
      link: "tt0227445"
    },
    {
      src: Jeepers_Creepers,
      alt: "Jeepers Creepers",
      link: "tt0263488"
    },
    {
      src: How_the_Grinch_Stole_Christmas,
      alt: "How the Grinch Stole Christmas",
      link: "tt0170016"
    },
    {
      src: Dracula,
      alt: "Dracula",
      link: "tt0103874"
    },
    {
      src: Quills,
      alt: "Quills",
      link: "tt0180073"
    },
    {
      src: Thirteen_Days,
      alt: "Thirteen Days",
      link: "tt0146309"
    },
    {
      src: Say_It_Isnt_So,
      alt: "Say It Isn't So",
      link: "tt0239949"
    },
    {
      src: Shrek,
      alt: "Shrek",
      link: "tt0126029/"
    },
    {
      src: Chocolat,
      alt: "Chocolat",
      description: "This was a good movie. Everyone should eat a little bit of chocolate.",
      link: "tt0241303"
    },
    {
      src: Bounce,
      alt: "Bounce",
      description: "How would you feel if you switched places with someone and they ended up dying? Another one worth watching.",
      link: "tt0186894"
    },
    {
      src: Crouching_Tiger_Hidden_Dragon,
      alt: "Crouching Tiger, Hidden Dragon",
      description: "Excellent movie. Full of action from the beginning to the end. After about 10 minutes you don't even notice the sub-titles.",
      link: "tt0190332"
    },
    {
      src: The_Wedding_Planner,
      alt: "The Wedding Planner",
      description: "If you are looking for a nice romantic movie then you might want to pick this one up.",
      link: "tt0209475"
    },
    {
      src: Traffic,
      alt: "Traffic",
      description: "Definitely worth watching. The movie is about drug trafficking and how it affects all of us. There are several intertwined stories weaving their way throughout.",
      link: "tt0181865"
    },
    {
      src: Save_the_Last_Dance,
      alt: "Save the Last Dance",
      description: "This movie is not that bad. I wasn't expecting much, but the movie was surprisingly well done.",
      link: "tt0206275"
    },
    {
      src: The_Family_Man,
      alt: "The Family Man",
      description: "This is a new twist on Scrooged. A very good romantic comedy.",
      link: "tt0218967"
    },
    {
      src: The_6th_Day,
      alt: "The 6th Day",
      description: "So, do you think that someday we will be able to clone humans? Well this is one movie that you might want to see.",
      link: "tt0216216"
    },
    {
      src: Best_in_Show,
      alt: "Best in Show",
      description: "If you just want to watch a totally wacky movie then this is the movie for you.",
      link: "tt0218839"
    },
    {
      src: Miss_Congeniality,
      alt: "Miss Congeniality",
      description: "I am glad I waited until it was on video to watch this. Then again maybe I should have waited until it was on TV.",
      link: "tt0212346"
    },
    {
      src: Pay_It_Forward,
      alt: "Pay It Forward",
      description: "This is one of the best movies I have seen in a long time.",
      link: "tt0223897"
    }
  ];
  
  const inTheaterMovies = [
    {
      src: Vanilla_Sky,
      alt: "Vanilla Sky",
      link: "tt0259711"
    },
    {
      src: KPAX,
      alt: "K-PAX",
      link: "tt0272152"
    },
    {
      src: Captain_Corellis_Mandolin,
      alt: "Captain Corelli's Mandolin",
      description: "This is a very good love story. Well worth watching.",
      link: "tt0238112"
    },
    {
      src: Rush_Hour_2,
      alt: "Rush Hour 2",
      description: "What can I say, it is another Jackie Chan movie. There is action from beginning to end. Add Chris Tucker in for some great laughs and this one is as good or better than the first one. Can't wait for number 3.",
      link: "tt0266915"
    },
    {
      src: American_Pie_2,
      alt: "American Pie 2",
      description: "If you liked the first one you will have a good time watching this one.",
      link: "tt0252866"
    },
    {
      src: Tomb_Raider,
      alt: "Tomb Raider",
      link: "tt0146316"
    },
    {
      src: Jurassic_Park_III,
      alt: "Jurassic Park III",
      link: "tt0163025"
    },
    {
      src: Americas_Sweethearts,
      alt: "America's Sweethearts",
      link: "tt0265029"
    },
    {
      src: Legally_Blonde,
      alt: "Legally Blonde",
      link: "tt0250494"
    },
    {
      src: Kiss_of_the_Dragon,
      alt: "Kiss of the Dragon",
      description: "If you like a lot of action this is a movie you will want to see.",
      link: "tt0271027"
    },
    {
      src: AI,
      alt: "AI",
      description: "The kid who played David, Haley Joel Osment, was excellent in this movie. Definitely worth watching.",
      link: "tt0212720"
    },
    {
      src: Bridget_Joness_Diary,
      alt: "Bridget Jones's Diary",
      description: "I went to see 'Bridget Jones's Diary' with Janet and my Mom. The movie was very good.",
      link: "tt0243155"
    },
    {
      src: The_Mexican,
      alt: "The Mexican",
      description: "I went to see 'The Mexican' with Janet, Christopher and my Mom. We all had a good time watching the movie.",
      link: "tt0236493"
    }
  ];

  return (
    <Content>
      <p><font size="6">Some Movies I Have Watched</font></p>
      <p align="center">
        <font size="4">
          My favorite movie is <a href="https://www.imdb.com/title/tt0087843" target="_blank" rel="noreferrer">Once Upon a Time in America</a>. 
          I will always enjoy a good drama, comedy, or action picture.  The only kinds 
          that I am not too fond of are horror and foreign films.  Here are some links 
          to the most recent movies that I have seen, and information about them.
        </font>
      </p> 
      <table cellSpacing="1" cellPadding="1" width="90%" border="0" align="center">
        <tbody>
          <tr valign="top">
            <td width="50%">
              <MovieTable title="On Video" movies={onVideoMovies} />
            </td>
            <td width="50%">
              <MovieTable title="In Theater" movies={inTheaterMovies} />
            </td>
          </tr>
        </tbody>
      </table>
    </Content>
  );
}

addRoute('/about-me-family', <AboutMeFamily />);
addRoute('/about-me-lived', <AboutMeLived />);
addRoute('/about-me-traveled', <AboutMeTraveled />);
addRoute('/about-me-worked', <AboutMeWorked />);
addRoute('/about-me-entertainment', <AboutMeEntertainment />);
addRoute('/about-me-comedy', <AboutMeComedy />);
